import React from "react";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import * as style from "./fullWidthResponsiveGraphic.module.scss"
const FullWidthResponsiveGraphic = ({blok}) => {
    return ( 
        <PanelWrapper blok={blok}>
        <div key={blok._uid} className={style.graphic}>
            {blok.title ? <h3 className={style.title}>{blok.title}</h3> : null}
            <picture>
                {blok.mobile_image && blok.mobile_image.filename !== "" ? <source media="(max-width:991px)" srcSet={blok.mobile_image.filename} st /> : null}
                {blok.desktop_image && blok.desktop_image.filename !== "" ? <img src={blok.desktop_image.filename} alt={blok.desktop_image.alt} style={{maxWidth: "100%", margin: "auto", display: "block"}} /> : null}
            </picture>
        </div>
        </PanelWrapper>
     );
}
 
export default FullWidthResponsiveGraphic;